
// The site's own chrome, in two roots of its own. <Header /> renders the fixed
// 72px bar AND its own spacer, so <main> needs no offset; it also renders the
// shell's stylesheet, which the reconciliation block above is written against.
// ⚠ NEVER id="site-footer" on either root: that id was the retired auto-mount
// opt-in that rendered twelve pages' footers twice, and tests/site-footer.test.mjs
// asserts its absence on every page.
ReactDOM.createRoot(document.getElementById("shape-chrome-header")).render(<Header active="App" />);
ReactDOM.createRoot(document.getElementById("shape-chrome-footer")).render(<Footer />);
